/**
 * RESPONSIBILITY: draw a picture and words one above the other, in the order the template names.
 *
 * The two templates differ only by which child comes first, so they are one component.
 */
import { Html } from '@framework/react';
import { Picture } from '../Picture';
import { BandFrame } from './BandFrame';
import { BandButtons } from './BandButtons';
import type { BandDef, BandProps } from './kind';

function Stacked({ b, tinted, imageFirst }: BandProps & { imageFirst: boolean }) {
  const pic = b.image?.path ? (
    <div key="p" className="ministry-pic-container">
      <Picture value={b.image} alt={b.image?.alt} className="block-pic ministry-section-pic" />
    </div>
  ) : null;
  const words = b.bodyHtml ? <Html key="w" className="md-body lede">{b.bodyHtml}</Html> : null;

  return (
    <BandFrame tinted={tinted} heading={b.heading}>
      {imageFirst ? [pic, words] : [words, pic]}
      <BandButtons b={b} />
    </BandFrame>
  );
}

const has = (b: BandProps['b']) => !!(b.bodyHtml || b.image?.path);

export const imageTop: BandDef = { has, Draw: (p) => <Stacked {...p} imageFirst /> };
export const textTop: BandDef = { has, Draw: (p) => <Stacked {...p} imageFirst={false} /> };
